import { Controller } from "@hotwired/stimulus";
import { Popover } from "bootstrap";

export default class extends Controller {
  copy(event) {
    event.preventDefault();
    navigator.clipboard.writeText(this.element.dataset.clipboardText);

    const toast = document.createElement("div");
    toast.classList.add(
      "toast",
      "align-items-center",
      "border-0",
      "text-bg-success"
    );
    toast.setAttribute("role", "alert");
    toast.setAttribute("aria-live", "assertive");
    toast.setAttribute("aria-atomic", "true");
    toast.setAttribute("data-toast-target", "toast");

    const container = document.createElement("div");
    container.classList.add("d-flex");

    const toastBody = document.createElement("div");
    toastBody.classList.add("toast-body", "d-flex", "align-items-top");
    toastBody.textContent = "Copied!";

    container.appendChild(toastBody);

    const button = document.createElement("button");
    button.classList.add("btn-close", "me-2", "m-auto");
    button.setAttribute("aria-label", "Close");
    button.setAttribute("data-action", "click->toast#close");
    button.type = "button";

    container.appendChild(button);
    toast.appendChild(container);

    document.querySelector("#flash").appendChild(toast);
  }
}
